import { Outlet } from "react-router-dom";
import { TenantProvider, useTenant } from "../lib/tenant.tsx";
import { TopBar } from "../components/TopBar.tsx";

function TenantInner() {
  const { info, loading, error } = useTenant();
  if (loading) return <div className="center-loading">carregando tenant…</div>;
  if (error) return <div className="center-loading">erro: {error}</div>;
  if (!info) return <div className="center-loading">tenant não encontrado</div>;
  return (
    <div className="app-shell">
      <TopBar />
      <main>
        <Outlet />
      </main>
    </div>
  );
}

export function TenantLayout() {
  return (
    <TenantProvider>
      <TenantInner />
    </TenantProvider>
  );
}
